const { inExperiment } = require('..');
const { CHAM_GROWTH_CAROUSEL_EXTERNAL_VISITS } = require('../experimentsEnum');

const inCarouselExternalVisitsExperiment =  (abTests) => inExperiment(CHAM_GROWTH_CAROUSEL_EXTERNAL_VISITS, abTests);

module.exports = {
    inCarouselExternalVisitsExperiment
};
